// client/src/pages/documents/Documents.js

import React from 'react';
import { Outlet } from 'react-router-dom';
import DocumentsNav from '../../components/DocumentsNav';

function Documents() {
  return (
    <div>
      <DocumentsNav />
      <Outlet />
    </div>
  );
}

export default Documents;
